import { useLomdaV3Editor } from "../store/useLomdaV3Editor";
import {
    DEFAULT_BLOCK_GAP,
    DEFAULT_GRID_GAP,
    DEFAULT_INNER_GAP,
} from "../lib/theme";

/**
 * Resolved spacing tokens. Each falls back through layers:
 * per-lomda content override → brand-kit/theme token → built-in default.
 */

/** Section gap (px): the vertical spacing between top-level sections. */
export function useResolvedBlockGap(): number {
    return useLomdaV3Editor(
        (s) =>
            s.content.blockGap ??
            s.metadata.theme?.sectionGap ??
            DEFAULT_BLOCK_GAP
    );
}

/** Grid gap (px) for a block — the spacing between items inside it. */
export function useResolvedGridGap(blockId: string): number {
    return useLomdaV3Editor(
        (s) =>
            s.content.blockGridGaps?.[blockId] ??
            s.content.gridGap ??
            s.metadata.theme?.gridGap ??
            DEFAULT_GRID_GAP
    );
}

/** Inner gap (px): spacing inside one section (title/paragraph/button/etc.). */
export function useResolvedInnerGap(): number {
    return useLomdaV3Editor(
        (s) =>
            s.content.innerGap ??
            s.metadata.theme?.innerGap ??
            DEFAULT_INNER_GAP
    );
}

/** Block width as a % of the content area (100 = full width). */
export function useResolvedBlockWidth(blockId: string): number {
    return useLomdaV3Editor((s) => s.content.blockWidths?.[blockId] ?? 100);
}
